export enum I18nNamespace {
  brand = "brand",
  translation = "translation",
}
